/*
 * @Author: liyxt
 * @Date: 2020-05-19 15:47:39
 * @LastEditors: liyxt
 * @LastEditTime: 2020-05-28 14:51:00
 * @Description: file content
 */ 
import React, { Component } from 'react';
import OriginMenu from 'bee-menus';
import { getSysFieldid } from '@platform/api';

require('bee-menus/build/Menu.css');
require('./index.less');

class Menu extends Component {
    render() {
        return <OriginMenu {...this.props} className={`${this.props.className || ''} nc-menu`} />;
    }
}

class Item extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        let { fieldid, ...others } = this.props;
        if (fieldid) {
            fieldid = `${fieldid}_sub-btn`;
        }
        return <OriginMenu.Item fieldid={getSysFieldid(fieldid) || null} {...others} />;
    }
}

Menu.SubMenu = OriginMenu.SubMenu;
Menu.ItemGroup = OriginMenu.ItemGroup;
Menu.Item = Item;
Menu.Divider = OriginMenu.Divider;
export default Menu;
